export default __webpack_public_path__ + "static/media/arrow_drop_down-Blue.ebaeec8e.svg";